import { createReducer, createAction } from '@reduxjs/toolkit';
import { AuthUser } from 'types/User';
import { SessionSlice } from 'types/State';

export const setHasClosedAdhesionAd = createAction('session/hasClosedAdhesionAd');

export const signedIn = createAction<AuthUser>('session/signedIn');
export const signedOut = createAction('session/signedOut');

export const sessionInitialState: SessionSlice = {
  hasClosedAdhesionAd: false,
  isSignedIn: undefined,
};

export const sessionReducer = createReducer(sessionInitialState, {
  [setHasClosedAdhesionAd.type]: (state) => {
    return { ...state, hasClosedAdhesionAd: true };
  },
  [signedIn.type]: (state) => {
    return { ...state, isSignedIn: true };
  },
  [signedOut.type]: (state) => {
    return { ...state, isSignedIn: false };
  },
});
